import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";

import { BouncingDots } from "@lifepay/rc-ui-toolkit";

function CacheSpinner(props) {
  const { theme, spin, children, spinner } = props;

  const spinnerNode = spinner || (
    <div className={classnames(theme.wrapper)}>
      <BouncingDots />
    </div>
  );

  return spin ? spinnerNode : children;
}

CacheSpinner.displayName = "CacheSpinner";

CacheSpinner.propTypes = {
  theme: PropTypes.object,
  children: PropTypes.node,
  spinner: PropTypes.node,
  spin: PropTypes.bool,
};

CacheSpinner.defaultProps = {
  spin: false,
};

export default themr("@lifepay/rc-ui-toolkit/login/SessionSpinner")(CacheSpinner);



// WEBPACK FOOTER //
// ./src/components/layout/CacheSpinner/CacheSpinner.js